import { T_DateRange } from "@app/_shared_components/DateFilter";
import { useMemberQueries } from "@app/entities/member/queries";
import { useReportQueries } from "@app/entities/report/queries";
import { T_Report } from "@app/entities/report/types";
import dayjs from "dayjs";
import { download, generateCsv, mkConfig } from "export-to-csv";
import { useState } from "react";

const csvConfig = mkConfig({
  filename: `Stats-${new Date().toLocaleDateString().replace(/\//gi, ".")}`,
  useKeysAsHeaders: true,
});

export const useStatsLoader = () => {
  const [showActive, setShowActive] = useState(true);
  const [showBad, setShowBad] = useState(false);
  const [showClaimed, setShowClaimed] = useState(false);
  const [fromDate, setFromDate] = useState(
    dayjs(new Date()).startOf("day").format("YYYY-MM-DD"),
  );
  const [toDate, setToDate] = useState(
    dayjs(new Date()).endOf("day").format("YYYY-MM-DD"),
  );
  const { getAllReports } = useReportQueries();
  const { getMembers } = useMemberQueries();
  const { allReports, isAllReportsPending } = getAllReports({
    fromDate,
    toDate,
  });
  const { members, isMembersPending } = getMembers();

  const handleDateChange = async ({ fromDate, toDate }: T_DateRange) => {
    setFromDate(dayjs(fromDate).format("YYYY-MM-DD"));
    setToDate(dayjs(toDate).format("YYYY-MM-DD"));
  };

  const handleExportStats = () => {
    if (!allReports?.length) return;
    const csv = generateCsv(csvConfig)(allReports);
    download(csvConfig)(csv);
  };

  function filterReports(report: T_Report): boolean {
    switch (report.status) {
      case "a":
        return showActive;
      case "b":
        return showBad;
      case "c":
        return showClaimed;
      default:
        return false;
    }
  }

  const activeReportCount = allReports?.filter(
    (report: T_Report) => report.status === "a",
  ).length;
  const badReportCount = allReports?.filter(
    (report: T_Report) => report.status === "b",
  ).length;
  const claimedReportCount = allReports?.filter(
    (report: T_Report) => report.status === "c",
  ).length;

  const isLoading = isAllReportsPending || isMembersPending;
  return {
    activeReportCount,
    badReportCount,
    claimedReportCount,
    handleDateChange,
    handleExportStats,
    isLoading,
    members,
    reports: allReports?.filter(filterReports),
    setShowActive,
    setShowBad,
    setShowClaimed,
    showActive,
    showBad,
    showClaimed,
  };
};
